import {
  Button,
  Grid,
  Typography,
  Divider as MuiDivider,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { spacing } from "@mui/system";
import React, { FC, Fragment, PropsWithChildren, useMemo } from "react";

import { BreadcrumList } from "../BreadcrumList";
import { useBreadcrum } from "../BreadcrumContext";
import IcIcon from "../IcIcon";

const Divider = styled(MuiDivider)(spacing);
export interface SearchLayoutAction {
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  icon?: string;
  onClick?: () => any;
  title?: string;
  disabled?: boolean;
  variant?: "text" | "outlined" | "contained";
  CustomComponent?: React.ComponentType;
}
export type SearchLayoutProps = PropsWithChildren<{
  actions?: SearchLayoutAction[];
  title?: string;
}>;

const ActionsHandler: FC<{ actions: SearchLayoutProps["actions"] }> = ({
  actions,
}) => {
  return (
    <>
      {actions?.map((a, i) => {
        const color = a.color || "primary";
        const variant = a.variant || "contained";
        if (a.CustomComponent) {
          return (
            <Fragment key={`${a.title}-${i}`}>
              <Box sx={{ marginLeft: 2 }}>
                <a.CustomComponent />
              </Box>
            </Fragment>
          );
        }
        return (
          <Fragment key={`${a.title}-${i}`}>
            <Box sx={{ marginLeft: 2 }}>
              <Button
                disabled={a.disabled}
                variant={variant}
                color={color}
                onClick={() => {
                  a.onClick && a.onClick();
                }}
              >
                {a.icon && <IcIcon icon={a.icon} />}
                {a.title}
              </Button>
            </Box>
          </Fragment>
        );
      })}
    </>
  );
};

export const SearchLayout = ({
  title,
  children,
  actions,
}: SearchLayoutProps) => {
  const { items } = useBreadcrum();

  return (
    <>
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            {title}
          </Typography>

          <BreadcrumList items={items} />
        </Grid>
        <Grid item sx={{ display: "flex" }}>
          <ActionsHandler actions={actions} />
        </Grid>
      </Grid>

      <Divider my={6} />
      <Grid container spacing={6}>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </>
  );
};
